import { APP_INITIALIZER, InjectionToken, PLATFORM_ID, Provider } from '@angular/core';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';

export interface GoogleTagManagerWindow {
    dataLayer: unknown[];
}

export function provideGoogleTagManager(frontendSideIntegration = true, googleTagManagerId?: string): Provider {
    return {
        provide: APP_INITIALIZER,
        useFactory: (platformId: InjectionToken<object>, document: Document) =>
            initializeApp(platformId, document, frontendSideIntegration, googleTagManagerId),
        deps: [PLATFORM_ID, DOCUMENT],
        multi: true,
    };
}

function initializeApp(
    platformId: InjectionToken<object>,
    document: Document,
    frontendSideIntegration: boolean,
    googleTagManagerId?: string,
): () => void {
    return (): void => {
        if (!googleTagManagerId) {
            return; // No Google Tag Manager ID provided, so no action needed
        }

        if (isPlatformBrowser(platformId)) {
            const gtagWindow = window as unknown as GoogleTagManagerWindow;
            gtagWindow.dataLayer = gtagWindow.dataLayer || [];
            gtagWindow.dataLayer.push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js',
            });
        }

        if (isPlatformServer(platformId) || frontendSideIntegration) {
            const scriptElement = document.createElement('script');
            scriptElement.async = true;
            scriptElement.src = `https://www.googletagmanager.com/gtm.js?id=${googleTagManagerId}`;

            const firstScriptElement = document.getElementsByTagName('script')[0];
            firstScriptElement?.parentNode?.insertBefore(scriptElement, firstScriptElement);
        }
    };
}
